// src/.../sidebar/AddressSection.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, TextField } from '@mui/material';

function AddressSection({ value, readOnly = true, onChange }) {
  const { direccion, ciudad, estado, pais } = value || {};

  if (readOnly) {
    return (
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>Información Adicional & Dirección</Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">Dirección</Typography>
            <Typography sx={{ mt: .5 }}>{direccion || '—'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Ciudad</Typography>
            <Typography sx={{ mt: .5 }}>{ciudad || '—'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">Estado</Typography>
            <Typography sx={{ mt: .5 }}>{estado || '—'}</Typography>
          </Box>
          <Box>
            <Typography variant="caption" color="text.secondary">País</Typography>
            <Typography sx={{ mt: .5 }}>{pais || '—'}</Typography>
          </Box>
        </Box>
      </Box>
    );
  }

  // Modo edición
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Información Adicional & Dirección</Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
        <TextField
          size="small"
          label="Dirección"
          value={direccion || ''}
          onChange={(e) => onChange?.((p) => ({ ...p, direccion: e.target.value }))}
        />
        <TextField
          size="small"
          label="Ciudad"
          value={ciudad || ''}
          onChange={(e) => onChange?.((p) => ({ ...p, ciudad: e.target.value }))}
        />
        <TextField
          size="small"
          label="Estado"
          value={estado || ''}
          onChange={(e) => onChange?.((p) => ({ ...p, estado: e.target.value }))}
        />
        <TextField
          size="small"
          label="País"
          value={pais || ''}
          onChange={(e) => onChange?.((p) => ({ ...p, pais: e.target.value }))}
        />
      </Box>
    </Box>
  );
}

AddressSection.propTypes = {
  value: PropTypes.object,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default AddressSection;
